import { render, staticRenderFns } from "./micoapp_form.vue?vue&type=template&id=2be9facd"
import script from "./micoapp_form.vue?vue&type=script&lang=js"
export * from "./micoapp_form.vue?vue&type=script&lang=js"
import style0 from "./micoapp_form.vue?vue&type=style&index=0&id=2be9facd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports